<template v-if="resultsLoaded && lists.length > 0">
  <template v-for="(items, i) in lists">
    <li
      v-for="item in items"
      :key="item"
      :data-index="i + 1"
      class="Collection-Grid__Item"
    >
      <ProductCard :item="item" :ready="promoReady" :terms="terms" />
    </li>
  </template>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import ProductCard from '../Global/ProductCard.vue';
import { FetchCard } from '../ProductCards/Composables/FetchCards.js';
import { pubSub } from '@utils/PubSub';

const lists = ref([]);
const pointer = ref(0);
const resultsLoaded = ref(false);
const promoReady = ref(false);

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  terms: {
    type: Object,
    default: () => ({}),
  },
});
const arrayHolder = [];
const loadCards = async (card, length) => {
  const data = await FetchCard(card);
  arrayHolder.push(data);
  if (arrayHolder.length == length)
    lists.value = arrayHolder
      .sort((a, b) => {
        try {
          return a.item.index - b.item.index;
        } catch {
          return false;
        }
      })
      .filter((product) => product.item);
  if (lists.value.length >= 1) return (resultsLoaded.value = true);
};

const updateProps = () => {
  const array = JSON.parse(JSON.stringify(props.data));
  if (array.length == 0) resultsLoaded.value = true;
  else {
    removeAdditionalSections();
    for (let i = 0; i < array.length; i++) {
      pointer.value++;
      loadCards(array[i], array.length);
      // Update document title
      if (i == array.length - 1) {
        const plural = array.length > 1 ? 's' : '';
        const text = window.location.search.split('=').pop();
        const searchQueryTerm = decodeURI(text);
        document.title = `Search: ${array.length} result${plural} for "${searchQueryTerm}"`;
      }
    }
  }
};

const removeAdditionalSections = () => {
  setTimeout(() => {
    const sections = document.querySelectorAll('main > .shopify-section');
    sections.forEach((section, i) => {
      if (i !== 0) section.remove();
    });
  }, 500);
};

const removeStencils = () => {
  const stencils = document.querySelectorAll('.js-collection-stencils');
  if (stencils.length <= 0) return;

  stencils.forEach((stencil) => stencil.remove());
};

const mountPromo = () => {
  pubSub.unsubscribe('dy:promo:init', mountPromo);
  pubSub.publish('dy:promo:ready');
};

const mountFallback = () => {
  pubSub.publish('dy:promo:ready');
};

const setPromo = () => {
  promoReady.value = true;
};

pubSub.subscribe('dy:promo:init', mountPromo, mountFallback);
pubSub.subscribe('dy:promo:ready', setPromo);
onMounted(() => {
  updateProps();
});

watch(resultsLoaded, removeStencils);
</script>
